module.exports = __webpack_public_path__ + "static/media/5x7no2.c74b354e.jpg";